namespace app.support {

    export class AutofocusDirective implements ng.IDirective {

        public restrict: string = "A";

        public constructor(private $timeout: ng.ITimeoutService) {

        }

        public link(scope, element: ng.IAugmentedJQuery): void{
            this.$timeout(() => {
                element[0].focus();
            }, 1000);
        }

        public static factory(): ng.IDirectiveFactory{
            return ($timeout: ng.ITimeoutService) => {
                'ngInject'
                return new AutofocusDirective($timeout);
            }
        }

    }

    angular
        .module('app.support')
        .directive('stfAutofocus', AutofocusDirective.factory());
}